import { useIntl } from 'react-intl';

import { Flex } from '@/components/Flex';
import { RegisterWatchBanner } from '@/components/RegisterWatchBanner';
import { myAccountMessages } from '@/messages/myAccount';

export interface RegisterMyWatchBannerProps {
  onBuyWatchClick: () => void;
  onRegisterWatchClick: () => void;
}

export const RegisterMyWatchBanner = ({
  onBuyWatchClick,
  onRegisterWatchClick,
}: RegisterMyWatchBannerProps) => {
  const { formatMessage } = useIntl();
  return (
    <RegisterWatchBanner
      data-test-id='RegisterMyWatchBanner'
      heading={formatMessage(myAccountMessages.accountWatchesEmptyTitle)}
      type='register watch'
    >
      <RegisterWatchBanner.Text data-test-id='RegisterMyWatchBannerText'>
        {formatMessage(myAccountMessages.accountWatchesEmptyDescription)}
      </RegisterWatchBanner.Text>
      <Flex
        data-test-id='RegisterMyWatchBannerFlex'
        flexDirection='column'
        gridGap={2}
      >
        <RegisterWatchBanner.CTA
          data-test-id='RegisterMyWatchBannerCTA'
          onClick={onRegisterWatchClick}
          variant='primary'
        >
          {formatMessage(myAccountMessages.accountWatchesRegisterCta)}
        </RegisterWatchBanner.CTA>
        <RegisterWatchBanner.CTA
          data-test-id='RegisterMyWatchBannerCTA-1'
          onClick={onBuyWatchClick}
          variant='outlined'
        >
          {formatMessage(myAccountMessages.accountWatchesBuyCta)}
        </RegisterWatchBanner.CTA>
      </Flex>
    </RegisterWatchBanner>
  );
};

RegisterMyWatchBanner.displayName = 'RegisterMyWatchBanner';
